"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactResponsiveCarousel = require("react-responsive-carousel");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Carousel = _ref => {
  let {
    id,
    autoPlay = false,
    infiniteLoop = false,
    interval = 3000,
    children
  } = _ref;
  const resetAnimations = (index, element) => {
    const carousel = document.getElementById("".concat(id));
    if (carousel) {
      const animatedElements = carousel.getElementsByClassName('animated');
      for (let i = animatedElements.length - 1; i > 0; i--) {
        let ele = animatedElements[i];
        ele.classList.remove('animated');
        ele.classList.add('animated');
      }
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactResponsiveCarousel.Carousel, {
    id: id,
    onChange: resetAnimations,
    autoPlay: autoPlay,
    infiniteLoop: infiniteLoop,
    showArrows: false,
    showThumbs: false,
    interval: interval,
    statusFormatter: () => {
      return "";
    },
    children: children
  });
};

/* Carousel.propTypes = {
  id: PropTypes.string.isRequired,
  colorInvert: PropTypes.bool,
}; */
var _default = exports.default = Carousel;